module.exports = __webpack_public_path__ + "media/site_templates/www.cabinetmaker.company/images/our_services_2-9cbab9119e2377629fbf711f06184f3e.jpg";